import type { DocMigration } from "../docMigration";

// Every addToXPlan label that gates whether an electrical controller (a switch, dimmer,
// sensor, or opener stored as an "electricalDevices" entity with deviceType CONTROLLER)
// is drawn on a plan. Electrical controllers will default to "addToElectricalPlan" being true
// all others false
const migration: DocMigration = {
  id: "20260707_add_plan_labels_to_electrical_controllers",
  description: "Backfill addToXPlan labels onto existing electrical controllers so they don't disappear from plans",
  apply(json: any): any {
    json.electricalDevices = json.electricalDevices ?? {};
    const electricalDevices = json.electricalDevices;
    for (const id of Object.keys(electricalDevices)) {
      const device = electricalDevices[id];
      if (device.deviceType !== "CONTROLLER") {
        continue;
      }

      device.labels ??= {};
      device.labels["addToElectricalPlan"] = true;
    }
    return json;
  },
};

export default migration;
